import { useMemo } from 'react';
import { LobbyType } from '../../../features/workflow/types';

export const useGroupName = (group: LobbyType | undefined) => {
  return useMemo(() => {
    switch (group) {
      case LobbyType.Inbox:
        return 'Agent';
      case LobbyType.Folio:
        return 'Folio';
      default:
        return '';
    }
  }, [group]);
};
